import { render, staticRenderFns } from "./FundsBuilder.vue?vue&type=template&id=5d14cde7&"
import script from "./FundsBuilder.vue?vue&type=script&lang=ts&setup=true&"
export * from "./FundsBuilder.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports